/* DSL Color-mode toggle — auto / dark / light cycle */
(function(){
  var KEY = "dsl_theme";
  var current = (function(){ try { return localStorage.getItem(KEY); } catch(e){ return null; } })() || "auto";
  function apply(t){ document.documentElement.dataset.theme = t; current = t; try { localStorage.setItem(KEY, t); } catch(e){} }
  apply(current);
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-theme-toggle]")) return;
    var nxt = current === "auto" ? "dark" : (current === "dark" ? "light" : "auto");
    apply(nxt);
    if (window.DSL_AB) window.DSL_AB.track("theme_toggle", {to: nxt});
  });
})();